import React from 'react';

import useFilter from '../../utilities/useFilter';
import InlineEditorWrapper from '../../utilities/InlineEditorWrapper';
import ListView from '../shared/lists/ListView';
import AdAmountItem from './AdAmountItem';
import AdAmountEditor from './AdAmountEditor';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import SelectList from '../shared/inputs/SelectList';

const AdAmountView = (props) => {
    const getUrl = '/api/ad/list';
    const postUrl = `/api/ad/edit`;
    const editUrl = `/api/ad/edit/`;
    const deleteUrl = `/api/ad/delete`;
    const defaultFilter = {
        searchObject: {
            franchiseId: window.biztrax.franchiseId,
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear()
        },
        sortColumn: 'SubLeadSourceName'
    }

    const { items, filter, setFilter, setData, submitFilter, pageInfo, isLoaded } = useFilter(getUrl, defaultFilter, true, 'searchObject');

    //submit filter on changes
    const updateData = (e) => {

        setFilter(e);
        submitFilter();
    }

    const canAdd = items.filter(i => i.id === 0).length === 0;

    function addNew() {
        const currentData = JSON.parse(JSON.stringify(items));
        if (canAdd) {
            currentData.push({
                id: 0,
                subLeadSourceId: 0,
                amount: '',
                effectiveMonth: filter.searchObject.month,
                effectiveYear: filter.searchObject.year,
                franchiseId: filter.searchObject.franchiseId
            });
            setData(currentData);
        }
    }

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <SortableTh sortName="SubLeadSourceName" sort={pageInfo}>Sub Lead Source</SortableTh>
                <SortableTh sortName="Amount" sort={pageInfo}>Amount</SortableTh>
                <th className="two-button-cell">&nbsp;</th>
            </tr>
        </thead>
    );

    const adAmounts = items.map((item) =>
        <InlineEditorWrapper
            isNew={item.id === 0}
            key={item.id}
            editItem={props.editItem}
        >
            <AdAmountItem
                item={item}
                fetchData={submitFilter}
                deleteUrl={deleteUrl}
            />
            <AdAmountEditor
                item={item}
                getUrl={editUrl + item.id}
                postUrl={postUrl}
                fetchData={submitFilter}
                cancelEdit={submitFilter}
                franchiseId={filter.franchiseId}
            />
        </InlineEditorWrapper>
    );

    const yearOptions = () => {
        const yearArray = [];
        for (let i = 2016; i < 2035; i++) {
            yearArray.push(i);
        }
        return yearArray.map((year, index) =>
        (
            <option key={index} value={year}>{year}</option>
        ));
    }

    return (
        <React.Fragment>
            <Form.Row className="justify-content-around">
                {window.biztrax.showFranchise &&
                    <Col sm="6">
                        <Form.Group as={Row}>
                            <Col xs="auto">
                                <Form.Label className="col-form-label-sm">
                                    Franchise
                                </Form.Label>
                                <SelectList
                                    name="searchObject.franchiseId"
                                    value={filter.searchObject.franchiseId}
                                    lookupType="Franchise"
                                    onChange={updateData} />
                            </Col>
                        </Form.Group>
                    </Col>
                }
                <Col sm="6">
                    <Form.Group as={Row}>
                        <Col xs="auto">
                            <Form.Label className="col-form-label-sm">
                                Month
                            </Form.Label>
                            <SelectList
                                name="searchObject.month"
                                value={filter.searchObject.month}
                                onChange={updateData}
                            >
                                <option value="1">January</option>
                                <option value="2">February</option>
                                <option value="3">March</option>
                                <option value="4">April</option>
                                <option value="5">May</option>
                                <option value="6">June</option>
                                <option value="7">July</option>
                                <option value="8">August</option>
                                <option value="9">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </SelectList>
                        </Col>
                        <Col xs="auto">
                            <Form.Label className="col-form-label-sm">
                                Year
                            </Form.Label>
                            <SelectList
                                name="searchObject.year"
                                value={filter.searchObject.year}
                                onChange={updateData}
                            >
                                {yearOptions()}
                            </SelectList>
                        </Col>
                    </Form.Group>
                </Col>
            </Form.Row>
            <Row>
                <Col>
                    <ListView
                        items={adAmounts || []}
                        tableHead={tableHead}
                        canAdd={canAdd}
                        itemName="Ad Amount"
                        addItem={addNew}
                        isLoaded={isLoaded}
                        pageInfo={pageInfo} />
                </Col>
            </Row>
        </React.Fragment >
    );
}

export default AdAmountView;